import { createBrowserClient } from "@supabase/ssr";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

/** Клиент для браузера: сессия хранится в cookies, доступна и на сервере при SSR. */
export const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey);
